import styled from 'styled-components';
import { globalTheme } from '@cld/component-theme';
import { typography } from '@cld/typography';

export const TextLine = styled.div`
  ${typography.xs.regular};
  padding-bottom: ${globalTheme.spacing.sm};
  display: flex;
  align-items: center;
`;
